export class InlineHookService {
    constructor(editor, hooks = {}) {
        this.editor = editor;
        this.hooks = hooks;
    }
}
//# sourceMappingURL=hook.js.map